import axios from 'axios'
import { useAuthStore } from '@/stores/authStore'

// 모든 API 요청의 베이스 경로.
// dev:  .env.development 의 VUE_APP_API_BASE (→ vue.config.js 프록시로 전달)
// prod: .env.production  의 VUE_APP_API_BASE (운영 origin 또는 절대 URL)
// 환경변수 미정의 시엔 '/api' 로 fallback.
export const API_BASE = process.env.VUE_APP_API_BASE || '/'

// 레거시 /node/api/* 엔드포인트(wav, fft, login_ex 등) 베이스.
// 컴포넌트에서 this.URL + 'api/...' 형태로 쓰이므로 끝이 '/' 로 끝나야 함.
//export const NODE_BASE = process.env.VUE_APP_NODE_BASE || 'https://dev.neverlosewater.com/node/'
export const NODE_BASE = process.env.VUE_APP_NODE_BASE || '/'

//export const api = axios.create({ baseURL: NODE_BASE })
export const api = axios.create({ baseURL: NODE_BASE })

// api.interceptors.request.use((config) => {
//   const auth = useAuthStore()
//   if (auth.credentials) {
//     config.headers.Authorization = `Basic ${auth.credentials}`
//   }
//   return config
// })

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const auth = useAuthStore()
      auth.logout()
    }
    return Promise.reject(err)
  },
)
